'use client';

import { c as _c } from "react/compiler-runtime";
import { type PropsWithChildren, useEffect, useRef, useState } from 'react';
import { Zoomable, type ZoomableProps } from '@/components/Zoomable/Zoomable';
export interface ZoomableImageResponsiveWrapperProps extends PropsWithChildren {
  height: number;
  width: number;
  zoomable?: Pick<ZoomableProps, 'children' | 'className' | 'controls'>;
}
type ContainerSize = {
  height: number;
  width: number;
};
const zoomFactor = 6;
export function ZoomableImageResponsiveWrapper(t0) {
  const $ = _c(14);
  const {
    children,
    height,
    width,
    zoomable
  } = t0;
  const containerRef = useRef(null);
  const [size, setSize] = useState();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handleResize = () => {
        if (containerRef.current) {
          const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
          const element = containerRef.current.parentElement || containerRef.current;
          setSize({
            height: element.offsetHeight,
            width: element.offsetWidth + scrollbarWidth
          });
        }
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => {
        containerRef.current = null;
        window.removeEventListener("resize", handleResize);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const scale = size ? Math.min(size.width / width, size.height / height) : 0;
  let t3;
  if ($[2] !== size) {
    t3 = {
      wrapperStyle: {
        ...size
      }
    };
    $[2] = size;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `${scale}`;
  const t5 = size !== undefined;
  const t6 = scale * zoomFactor;
  let t7;
  if ($[4] !== scale || $[5] !== t6) {
    t7 = {
      initialScale: scale,
      minScale: scale,
      maxScale: t6
    };
    $[4] = scale;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== children || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t7 || $[12] !== zoomable) {
    t8 = <Zoomable {...zoomable} contentProps={t3} key={t4} ready={t5} ref={containerRef} wrapperProps={t7}>{children}</Zoomable>;
    $[7] = children;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
    $[12] = zoomable;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}